import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import ReactMarkdown from "react-markdown";
import { useCompetitionsRetrieve } from "@/api/generated/backendAPI";
import Submissions from "@/components/submissions/Submissions";
import FileUpload from "@/components/submissions/FileUpload";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { queryClient } from "@/main";

export const Route = createFileRoute(
  "/_layout/_auth/competitions/$licenseId/submission"
)({
  component: CompetitionSubmission,
});

function CompetitionSubmission() {
  const [uploadingProcess, setUploadingProcess] = useState(false);
  const { licenseId } = Route.useParams();
  const { data: competitionData, refetch } = useCompetitionsRetrieve(licenseId);
  const closeModal = async (uploaded = false) => {
    setUploadingProcess(false);
    queryClient.invalidateQueries();
    if (uploaded) {
      await refetch();
    }
  };
  return (
    <>
      <h2 className="mt-4">投稿</h2>
      <ReactMarkdown className="markdown">
        {competitionData?.licensedCompetition.submissionNote}
      </ReactMarkdown>

      <div className="flex items-center justify-center my-8 ">
        {new Date(competitionData?.endDatetime || "") < new Date() ? (
          <button className="border-graycolor bg-graycolor">
            投稿受付は終了しています
          </button>
        ) : new Date(competitionData?.startDatetime || "") > new Date() ? (
          <button className="border-graycolor bg-graycolor">
            投稿受付前です
          </button>
        ) : (
          <button onClick={() => setUploadingProcess(true)}>
            ファイルをアップロード
          </button>
        )}
      </div>
      <h3 className="my-4 text-lg font-bold">投稿履歴</h3>
      <Submissions
        mySubmissions={competitionData?.mySubmissions}
        rankedSubmission={competitionData?.rankedSubmissions}
        licenseId={licenseId}
        submissionType={competitionData?.licensedCompetition.submissionType}
      />
      {uploadingProcess && (
        <FileUpload
          closeModal={closeModal}
          submissionType={
            competitionData?.licensedCompetition.submissionType || "results"
          }
          licenseId={licenseId}
          competitionId={competitionData?.licensedCompetition.id || 0}
          evaluationMetricsName={
            competitionData?.licensedCompetition.evaluationMetrics?.name
          }
        />
      )}
      <ToastContainer />
    </>
  );
}
